import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=fabbfba0&scoped=true"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=fabbfba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabbfba0",
  null
  
)

export default component.exports